export {default as PeriodicTable} from "./components/PeriodicTable"